import React, { useState, useRef, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import cn from "classnames";
import styles from "./Popover.module.sass";
import Icon from "../Icon";

const Popover = ({ className, actionable, children, title, portal = false, solidBackground = false }) => {
  const [visible, setVisible] = useState(false);
  const headRef = useRef(null);
  const [portalPosition, setPortalPosition] = useState({ bottom: 0, right: 0 });

  useLayoutEffect(() => {
    if (portal && visible && headRef.current) {
      const rect = headRef.current.getBoundingClientRect();
      setPortalPosition({
        bottom: window.innerHeight - rect.top + 12,
        right: window.innerWidth - rect.right - 24,
      });
    }
  }, [portal, visible]);

  const bodyContent = (
    <div
      className={cn(styles.body, { [styles.bodyPortal]: portal, [styles.bodySolid]: solidBackground })}
      style={portal && visible ? { position: "fixed", bottom: portalPosition.bottom, right: portalPosition.right } : undefined}
    >
      <div className={styles.top}>
        <div className={cn("title-red", styles.title)}>{title}</div>
        <button type="button" className={styles.close} onClick={() => setVisible(false)}>
          <Icon name="close" size="20" />
        </button>
      </div>
      {children}
    </div>
  );

  return (
    <div
      className={cn(styles.filters, className, { [styles.active]: visible })}
      data-popover
    >
      <div className={styles.popoverContent}>
        <button
          ref={headRef}
          type="button"
          className={cn("", styles.head)}
          onClick={() => (portal ? setVisible(!visible) : setVisible(true))}
        >
          {actionable}
        </button>
        {portal && visible ? createPortal(bodyContent, document.body) : bodyContent}
      </div>
      {portal && visible
        ? createPortal(
            <div className={cn(styles.overlay, styles.overlayPortal)} onClick={() => setVisible(false)} />,
            document.body
          )
        : <div className={styles.overlay} onClick={() => setVisible(false)} />}
    </div>
  );
};

export default Popover;
